/* global $:true module:true Flickity:true Foundation:true */
import $ from 'jquery';
import Flickity from "@core/vendor/flickity/flickity.pkgd.min@2.2.2.js";
import debug from "debug";
const ZERO = 0;
const MODULE_NAME = 'core/modules/sliders/blocks';
const log = debug(MODULE_NAME);
const SLIDE_CELL_SELECTOR = '.slide-cell .video-block__iframe';
const DOTS_SELECTOR = '.flickity-page-dots';
const DOTS_WRAPPER_CLASS = 'flickity-page-dots-wrapper';
const PREV_BUTTON_SELECTOR = '.flickity-button.previous';
const NEXT_BUTTON_SELECTOR = '.flickity-button.next';
const EVO_NEXT_BUTTON_SVG = '<svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.7" d="M2 18.5L10.5 10L2 1.5" stroke="" stroke-width="4"/></svg>';
const EVO_PREV_BUSSON_SVG = '<svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.7" d="M11.5 1.5L3 10L11.5 18.5" stroke="" stroke-width="4"/></svg>';

function setSlideHeights() {
	log('setSlideHeights');

	$('.block-slider')
		.each(function ReduceSliderHeightFn () {
			const slider = $(this);
			let height = 0;

			$(slider).find('.slide-cell')
				.css('height', 'auto');

			$(slider).find('.slide-cell')
				.each(function FindSlideHeight () {
					const cell = $(this);
					const cellHeight = cell.height();
					if (cellHeight > height) {
						height = cellHeight;
					}
				});

			$(slider).find('.slide-cell')
				.css('height', height);

			$(slider).addClass('height-set');

		});
}

function AddDotsWrappingElement() {
	log('sliderAddDotsWrappingElement');
	$('.block-slider')
		.each(function(){
			var element = this;

			//added a timeout as dots weren't being added correctly if multiple sliders on a page
			setTimeout(function(){

				if ($(element).find('.' + DOTS_WRAPPER_CLASS).length == 0) {
					var el = $(element).find(DOTS_SELECTOR).detach();
					var div = document.createElement('div');
					div.className = DOTS_WRAPPER_CLASS;
					$(element).append(div);
					$(element).find('.' + DOTS_WRAPPER_CLASS).append(el);
				}
			}, 200);
		});
}

function AddCustomNavigation() {
	$('.block-slider')
		.each(function(){
			const slider = $(this);
			var changeArrows = typeof($(slider).attr('data-arrow-shape')) !== 'undefined'
			&& $(slider).attr('data-arrow-shape') == 'evo';
			if (changeArrows) {
				setTimeout(function(){
					var nextButton = $(slider).find(NEXT_BUTTON_SELECTOR);
					var prevButton = $(slider).find(PREV_BUTTON_SELECTOR);
					if (typeof(nextButton) !== 'undefined' && typeof(prevButton) !== 'undefined') {
						$(nextButton).empty().append(EVO_NEXT_BUTTON_SVG);
						$(prevButton).empty().append(EVO_PREV_BUSSON_SVG);
					}
				}, 200);
			}
		});
}

function setupSliders() {
	log('setupSliders', isWebAnimationSupported());

	$('.block-slider')
		.each(function SetupSlider () {
			const slider = $(this);
			const sliderElement = $(slider).get(ZERO);
			const autoPlay = $(slider).attr('data-auto-play') === 'true';
			const arrowShape = 'M74.38,92.74a4.24,4.24,0,1,1-6,6c-.5-.47-1-1-1.45-1.46l-8.87-8.86L31.94,62.29,23.68,54a9,9,0,0,1-1.88-2.21c-1-2-.12-3.9,1.32-5.34L43,26.63,66.08,3.52c.71-.71,1.41-1.42,2.12-2.12,2.24-2.2,6.14-1.73,7.2,1.47s-2.58,5.9-4.62,7.94l-24.6,24.6-11,11-3,3c-.09.09-.56.43-.57.56s.07.08.14.22.58.58.8.81L34,52.35l4.36,4.36L50.88,69.24,73.1,91.46Z';

			// Legacy edge native video player not playable with mouse inside flickity with dragging enabled
			const draggableEnabled = isWebAnimationSupported();

			const FlickityOptions = {
					autoPlay: autoPlay,
					wrapAround: true,
					freeScroll: false,
					bgLazyLoad: true,
					adaptiveHeight: false,
					draggable: draggableEnabled,
                    dragThreshold: 10,
					contain: true,
					cellAlign: 'left',
					groupCells: '100%',
					arrowShape: arrowShape,
					on: {
						change: function() {
							$(SLIDE_CELL_SELECTOR).each(function() {
								if (typeof($(this)[0].contentWindow) !== 'undefined') {
									$(this)[0].contentWindow.postMessage(
										'{"event":"command","func":"pauseVideo","args":""}',
										'*');
								}
							});
						},
						ready : function() {
							AddDotsWrappingElement();
							AddCustomNavigation();
						}
					}
			};

			var flick = new Flickity(sliderElement, FlickityOptions);
		});

	$(window).resize(() => {
		setSlideHeights();
	});
}

// Test designed to isolate Legacy Edge
function isWebAnimationSupported() {
	return ('animate' in document.documentElement);
}

export default function () {
	setSlideHeights();
	setupSliders();
}



// WEBPACK FOOTER //
// ./client/src/core/components/sliders/blocks.js